// Config (pass to TamaguiProvider)
export { config } from './tamagui/config'
export type { AppConfig } from './tamagui/config'

// Tokens & themes (for advanced use / custom components)
export { tokens, palette } from './tamagui/tokens'
export { themes, gardenLight, gardenDark, brickLight, brickDark } from './tamagui/themes'

// Fonts
export { headingFont, bodyFont } from './tamagui/fonts'

// Animations
export { animations } from './tamagui/animations'

// Elements
export { Button, ButtonText } from './elements/Button'
export { IconButton } from './elements/IconButton'
export { Text } from './elements/Text'
export { Input } from './elements/Input'
export { TextArea } from './elements/TextArea'
export { IconBadge } from './elements/IconBadge'
export { Badge, BadgeText } from './elements/Badge'
export { Chip, ChipText } from './elements/Chip'
export { Divider } from './elements/Divider'
export { Card } from './elements/Card'
export { Avatar } from './elements/Avatar'
export { Checkbox } from './elements/Checkbox'
export { ProgressSteps } from './elements/ProgressSteps'
export { Spinner } from './elements/Spinner'
export { FavoriteButton } from './elements/FavoriteButton'
export type { FavoriteButtonProps } from './elements/FavoriteButton'

// Composites
export { ButtonGroup } from './composites/ButtonGroup'
export { SearchInput } from './composites/SearchInput'
export { EmptyState } from './composites/EmptyState'
export { SectionHeader } from './composites/SectionHeader'
export { StatusBadge } from './composites/StatusBadge'
export { StatCard } from './composites/StatCard'
export { ActionCard } from './composites/ActionCard'
export { ListItem } from './composites/ListItem'
export { TopBar } from './composites/TopBar'
export { ProductCard } from './composites/ProductCard'
export { StoreCard } from './composites/StoreCard'
export { BottomNav } from './composites/BottomNav'
export { Toast } from './composites/Toast'
export { FilterTabs } from './composites/FilterTabs'
export { AlertCard } from './composites/AlertCard'
export { ValueCard } from './composites/ValueCard'
export { TabBar } from './composites/TabBar'
export { Dialog, DialogHeader, DialogBody, DialogActions } from './composites/Dialog'
export { Sheet } from './composites/Sheet'
export { LanguageSwitcher } from './composites/LanguageSwitcher'
export { FadingScrollView } from './composites/FadingScrollView'

// Layout
export { XStack, YStack, ZStack, ScrollView } from './layout'

// Fabs — fully assembled components (auto-resolve colors from variant/size)
export { ButtonFab, IconButtonFab, BadgeFab, ChipFab } from './fabs'

// Tamagui internals — only what's needed for provider setup and custom components
export {
  TamaguiProvider,
  Theme,
  useTheme,
  useThemeName,
  useMedia,
  styled,
  getTokens,
} from 'tamagui'
